module.exports = __webpack_public_path__ + "img/QY_4.e82396a1.png";